<template>
	<div class="content__form">
		<s-dialog-success v-model="showSuccess">
			<h3>Thank you!</h3>
			<p>Your request has been sent successfully</p>
		</s-dialog-success>
		<h2>SEO for pharmacy websites</h2>
		<h3>Free consultation. Success cases. Anonymity.</h3>
		<s-group class="form-group"  :has-error="nameError" :error-text="'Name is required'">
			<s-input id="name" v-model="name" :disableInputMobile="true"/>
			<label v-if="!name" for="name" v-html="'Name<span>*</span>'"></label>
		</s-group>
		<br>
		<s-group class="form-group" :has-error="emailError" :error-text="'* Enter correct e-mail'">
			<s-input id="email" type="email" v-model="email" :disableInputMobile="true"/>
			<label v-if="!email" for="email" v-html="'Email<span>*</span>'"></label>
		</s-group>
		<br>
		<s-group class="form-group" :has-error="siteUrlError" :error-text="'Please, enter the correct website URL'">
			<s-input id="siteUrl" type="text" v-model="siteUrl" :disableInputMobile="true"/>
			<label v-if="!siteUrl" for="siteUrl" v-html="'Website<span>*</span>'"></label>
		</s-group>
		<button class="form-group--button-reseller" @click="setData()">Request details</button>
		<p class="privacy-terms-of-service"><!--
			By entering your data you agree to <a class="underline" href="/terms-of-service" target="_blank">Terms of Service</a>
			<span> and </span><a class="underline" href="/privacy-policy" target="_blank">Privacy Policy</a>-->
		</p>
		<div class="content-form__underline"></div>
		<div class="content__form--form-footer">
			<img src="../assets/img/like-for-form.png" alt="">
			<p><span class="text-type4">Trusted by <span class="text-type5">100+</span></span> pharmacy website owners</p>
			<div class="content__form--form-footer__underline"></div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: "Form",
		data(){
			return{
				id: 0,
				name: '',
				nameError: false,
				nameTextError: '',
				email: '',
				emailError: false,
				emailTextError: '',
				siteUrl: '',
				siteUrlError: false,
				phone: '',
				phoneError: false,
				phoneTextError: '',
				managerName: '',
				errors: [],
				isRegister: false,
				lastAttempt: false,
				showSuccess: false,
				idUserSemalt: 0
			}
		},
		methods: {
			async setData(){
				this.validateInputName()
				this.validateInputEmail()
				this.validateInputSite()
				//await this.validateInputPhone()
				if(!this.siteUrlError && !this.emailError && !this.nameError) {
					this.showSuccess = true
					let config = {
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					};
					axios.post('https://semalt.com/ajax/reg/register.php', {
						q: 'register',
						subject: 'Reseller Program: ',
						email: this.email,
						username: this.name,
						domain: this.siteUrl.toLowerCase().trim(),
						statfilter:491,
						controller: location.href,
						referrer: document.referrer
					}, config)
						.then(response => {
							if(response.status ==200 && response.data){
								try {
									if(response.data.status=="OK" && response.data.id){
										this.idUserSemalt = response.data.id;
										this.sendRequestSemalt();
									}
									else if(response.data.status=="ERROR" && response.data.msg && response.data.msg=='USER_EXIST' && response.data.user){
										this.idUserSemalt = response.data.user;
										this.sendRequestSemalt();
									}
								}catch(e){}
							}
						})
						.catch(e => {
							this.errors.push(e)
						})
					this.lastAttempt = false
				} else this.lastAttempt = true
			},
			sendRequestSemalt(){
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				};
				axios.post('https://semalt.com/ajax/support/send_request.php', {
					q: 'seo_cosultation_header',
					idu: this.idUserSemalt,
					name: this.name,
					email: this.email,
					phone:'',
					url: this.siteUrl.toLowerCase().trim(),
					ref:'seo-traffic-to-websites.com'
				}, config)
					.then(response => {
						this.name = ''
						this.email = ''
						this.siteUrl = ''
						//console.log(response);
					})
					.catch(e => {
						this.errors.push(e)
					});
			},
			validateInputName() {
				this.nameError = false
				const res = this.$frontend.validate.empty(this.name)
				if (res === true) {
					this.nameError = true
					this.nameTextError = res
				}
			},
			validateInputEmail() {
				this.emailError = false
				const res = this.$frontend.validate.email(this.email)
				if (res !== true) {
					this.emailError = true
					this.emailTextError = res
				}
			},
			validateInputSite() {
				const res = this.$frontend.validate.website(this.siteUrl.toLowerCase().trim());
				if (res !== true) {
					this.siteUrlError = true
				} else {
					this.siteUrlError = false
				}
			},
			$t(param){
				let data = [];
				data[1] = 'Спасибо!';
				return data[param] ? data[param]:"";
			}
		},
		watch: {
			name() {
				if(this.lastAttempt === true) this.validateInputName()
			},
			email() {
				if(this.lastAttempt === true) this.validateInputEmail()
			},
			siteUrl() {
				if(this.lastAttempt === true) this.validateInputSite()
			},
		},
		mounted () {

		}
	}
</script>

<style lang="less" scoped>
	.content__form{
		-webkit-box-shadow: 0px 0px 30px 0px rgba(9,53,71,0.4);
		-moz-box-shadow: 0px 0px 30px 0px rgba(9,53,71,0.4);
		box-shadow: 0px 0px 30px 0px rgba(9,53,71,0.4);
		padding: 50px 50px 0 50px;
		background: #fff;
		width: 520px;
		border-radius: 30px;
		position: relative;
		h2{
			font-size: 25px;
			text-align: center;
			margin: 0;
		}
		h3{
			font-size: 16px;
			margin: 10px 0 15px 0;
			font-weight: 500;
		}
		div.form-group{
			position: relative;
			min-height: 62px;
			width: 100%;
			/deep/.s-group__content{
				/deep/.s-group__helper{
					margin: 2px 0 0 3px;
				}
			}

			/deep/.s-input{
				input{
					background: #eef1f9;
				}
			}
			/deep/.s-input-tel{
				width: 100%;
				height: 40px;
				min-width: 0;
				/deep/.s-select__header{
					height: 40px;
					background: #eef1f9;
				}
			}
			label{
				cursor: text;
				&:hover{
					cursor: text;
				}
				&:focus{
					cursor: text;
				}
				position: absolute;
				z-index: 2;
				top: 10px;
				left: 17px;
				color: #b0b5c0;
				font-size: 14px;
				/deep/span{
					color: red;
				}
			}
		}
		button{
			height: 50px;
			width: 235px;
			background-color: #ff1f4a;
			border: none;
			color: #fff;
			font-size: 18px;
			border-radius: 5px;
			font-family: 'Raleway', sans-serif;
			line-height: 25px;
			display: block;
			margin: 0 auto;
			&:hover{
				cursor: pointer;
			}
			&:focus{
				outline: none;
			}
		}
		p{
			font-size: 12px;
			line-height: 18px;
			padding: 0 20px;
			text-align: center;
			font-weight: 500;
			a{
				color: #4b79bb;
				text-decoration: none;
				&:hover{
					text-decoration: underline;
				}
			}
		}
		.content-form__underline {
			position: absolute;
			border-bottom: 2px solid #eef1f9;
			width: 100%;
			left: 0;
		}
		.content__form--form-footer{
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 15px 0;
			position: relative;
			p{
				font-weight: 700;
				color: #093547;
				font-size: 18px;
				width: auto;
				/deep/span{
					color: #4b79bb;
				}
			}
			.content__form--form-footer__underline{
				position: absolute;
				border-bottom: 3px solid #ff1f4a;
				width: 60%;
				bottom: 0;
			}
		}
		h3{
			color: #093547;
			text-align: center;
		}
		/deep/.s-input{
			position: relative;
		}
		label{
			position: absolute;
		}
		/deep/ .s-group__helper__default{
			font-size: 12px;
			margin-top: -2px;
		}
	}
	/deep/.s-dialog-success-content__message{
		h3{
			font-size: 36px;
			font-weight: 700;
			font-family: 'Raleway', sans-serif;
			text-transform: uppercase;
			margin: 35px 0 25px 0;
			color: #2c3e50;
		}
		p{
			font-size: 18px;
			font-family: 'Raleway', sans-serif;
			color: #2c3e50;
		}
	}
	.privacy-terms-of-service{
		/deep/a{
			color: #4b79bb;
			text-decoration: none;
		}
	}
	@media (min-width: 2500px) {
		.content__form {
			padding: 30px 50px 0 50px;
		}
	}
	@media (min-width: 1200px) and (max-width: 1600px){
		.content__form {
			padding: 30px 50px 0 50px;
		}
	}
	@media (max-width: 992px) {
		.content__form{
			width: 400px;
			h3{
				font-size: 14px;
			}
			p{
				padding: 0 10px;
			}
			.content__form--form-footer{
				padding: 5px 0;
			}
		}
	}
	@media (max-width: 480px) {
		.content__form{
			width: 340px;
			padding: 30px 30px 0 30px;
			h3{
				font-size: 14px;
			}
			p{
				padding: 0 10px;
			}
			.content__form--form-footer{
				padding: 5px 0;
			}
		}
	}
	@media (max-width: 360px) {
		.content__form{
			width: 320px;
			padding: 20px 20px 0 20px;
		}
	}
</style>
